import { render, staticRenderFns } from "./modelUpdate.vue?vue&type=template&id=712f8635&scoped=true"
import script from "./modelUpdate.vue?vue&type=script&lang=js"
export * from "./modelUpdate.vue?vue&type=script&lang=js"
import style0 from "./modelUpdate.vue?vue&type=style&index=0&id=712f8635&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712f8635",
  null
  
)

export default component.exports